import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import TokenGroup from '../../assets/images/tokens/token-group.svg';
import Star from '../../assets/images/tokens/star.svg';
import {
    CommonModal,
    CommonModalProps,
    CommonModalContainer,
} from '../CommonModal';

export type FpeTokenModalProps = CommonModalProps & {
    onUseNow: () => void;
    onSaveLater: () => void;
};

const FpeTokenModalContainer = styled(CommonModalContainer)`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 62.5rem;
`;

const TokenGroupImage = styled(TokenGroup)`
    width: 18.25rem;
    height: 12.5rem;
    margin-bottom: 0.5rem;
`;

const Title = styled.p`
    font-family: Signika-Bold;
    font-size: 3.75rem;
    font-weight: bold;
    color: #ffffff;
    text-align: center;
    margin: 0 0 1.5rem;
`;

const UseNowWrapper = styled.div`
    position: relative;
    width: 25.5625rem;
    height: 4.8125rem;
    margin-bottom: 0.875rem;
`;

const UseNowButton = styled.button`
    width: 100%;
    height: 100%;
    border-radius: 1.25rem;
    border: 1px solid #003d4b;
    background-image: linear-gradient(to bottom, #a5d12f, #1bb604 98.9%);
    box-shadow: inset 0 4px 0 0 #d0fc5a;
    cursor: pointer;
    font-family: Signika-Bold;
    font-size: 2.5rem;
    font-weight: bold;
    color: #ffffff;
    padding: 0;
`;

const SaveLaterButton = styled.button`
    width: 25.5625rem;
    height: 4.8125rem;
    border-radius: 1.25rem;
    border: 3px solid #cccccc;
    background: transparent;
    cursor: pointer;
    font-family: Signika-Bold;
    font-size: 1.75rem;
    font-weight: bold;
    color: #ffffff;
    margin-bottom: 1.5rem;
`;

const Disclaimer = styled.p`
    font-family: Signika-Regular;
    font-size: 1.125rem;
    color: rgba(255, 255, 255, 0.85);
    text-align: center;
    margin: 0;
    max-width: 50rem;
`;

const StarDecoration = styled(Star)`
    position: absolute;
    width: 1.5625rem;
    height: 1.5625rem;
    pointer-events: none;
`;

const StarA = styled(StarDecoration)`
    left: -2.75rem;
    top: 0.375rem;
`;

const StarB = styled(StarDecoration)`
    right: -2.75rem;
    top: -0.8125rem;
`;

const StarC = styled(StarDecoration)`
    right: -4.5rem;
    top: 1.9375rem;
`;

export const FpeTokenModal: FC<FpeTokenModalProps> = ({
    onUseNow,
    onSaveLater,
    ...props
}) => {
    const { t } = useTranslation();

    return (
        <CommonModal {...props} Container={FpeTokenModalContainer}>
            <TokenGroupImage />
            <Title>{t('fpeTokenModal.title')}</Title>
            <UseNowWrapper>
                <StarA />
                <StarB />
                <StarC />
                <UseNowButton onClick={onUseNow}>
                    {t('fpeTokenModal.useNow')}
                </UseNowButton>
            </UseNowWrapper>
            <SaveLaterButton onClick={onSaveLater}>
                {t('fpeTokenModal.saveLater')}
            </SaveLaterButton>
            <Disclaimer>{t('fpeTokenModal.disclaimer')}</Disclaimer>
        </CommonModal>
    );
};
